// extracted by mini-css-extract-plugin
export default {"readyTo":"ReadyTo_readyTo__OSk9P","header":"ReadyTo_header__KKRES","btns":"ReadyTo_btns__MnQx2"};